const appConfig = {
  apiUrlBase: 'https://vmi.prd.mccolls.net.au/api',
};

export default appConfig;
